/* ============================================================
   The two pages the OAuth POPUP lands on (src/platform/oauth.ts). Each hands
   its result to the opener over the BroadcastChannel and closes the popup.
   They render outside every provider: a popup must never try to restore a
   session or hydrate a store of its own.
   ============================================================ */
import { useEffect } from 'react';

import { AUTH_CHANNEL, type AuthChannelMessage } from '../platform/oauth';

function post(message: AuthChannelMessage) {
  const channel = new BroadcastChannel(AUTH_CHANNEL);
  channel.postMessage(message);
  channel.close();
}

export function CallbackPage() {
  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    post({
      kind: 'callback',
      state: q.get('state'),
      code: q.get('code'),
      error: q.get('error'),
      errorDescription: q.get('error_description'),
    });
    window.close();
  }, []);
  return <PopupNote>Signing you in… you can close this window.</PopupNote>;
}

export function SignoutPage() {
  useEffect(() => {
    post({ kind: 'signout' });
    window.close();
  }, []);
  return <PopupNote>Signed out. You can close this window.</PopupNote>;
}

function PopupNote({ children }: { children: string }) {
  return <p className="p-8 text-center text-meta">{children}</p>;
}
